import { Injectable } from '@angular/core';
import { findElement, findFirstElement } from './TagsUtils';

declare const cornerstone: any;
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader/dist/dynamic-import/cornerstoneWADOImageLoader.min.js';
// declare const cornerstoneWADOImageLoader;

var toolsData: ToolsData[] = [];

interface ToolsData {
  referencedImageUID: string;
  data: string;
}

@Injectable({
  providedIn: 'root'
})
export class PresentationStateService {

  constructor() {
    cornerstone.metaData.addProvider(toolDataMetaDataProvider);
  }

  getToolDataForImageId(imageId: string) {
    const toolsMetadata = cornerstone.metaData.get(
      'toolDataProvider',
      imageId
    );

    // const data = (toolsMetadata) ? JSON.parse(toolsMetadata) : null;
    // return data;
    return toolsMetadata;
  }

  getToolDataForInstanceUID(instanceUID: string) {
    let toolData: string | null = null;

    toolsData.forEach((data, index) => {
      // console.log('getToolDataForInstanceUID', { instanceUID, referencedImageUID: data.referencedImageUID });
      if (data.referencedImageUID == instanceUID) {
        toolData = data.data;
        toolsData.splice(index, 1);
      }
    });
    if (toolData != null) {
      // console.log('length', toolData.length);
      return JSON.parse(toolData);
    }

    return null;
  }

}

function toolDataMetaDataProvider(type: string, imageId: string) {
  if (type === 'toolDataProvider') {

    // console.log('imageId', imageId);

    // const metaDataManager = null;
    const metaDataManager = cornerstoneWADOImageLoader.wadors.metaDataManager;
    const metaData = metaDataManager.get(imageId);
    // console.log('metaData', metaData);
    if (!metaData) {
      return;
    }

    const imageUID = findFirstElement(metaData, 'x00080018');



    let toolData: string | null = null;
    // console.log('toolsDataAA', toolsData);
    toolsData.forEach((data, index) => {
      if (data.referencedImageUID == imageUID) {
        toolData = data.data;
        toolsData.splice(index, 1);
      }
    });
    if (toolData) {
      // console.log('toolData', toolData);
      // console.log('length', toolData.length);
      return JSON.parse(toolData);
    }
  }
}

export function addToProvider(dataset: any, referencedImageUID?: string) {
  if (referencedImageUID == null) {
    const uids: string[] = [];
    findElement(dataset, 'x00081155', uids);
    // console.log('uids', uids);
    referencedImageUID = uids[0];
  }

  // Buscar en:
  // (0070,0001) SQ GraphicAnnotationSequence
  //    (0070,0002) CS GraphicLayer  - NOMBRE DE LA CAPA
  //    (0070,0009) SQ GraphicObjectSequence
  //      (0070,0021) US NumberOfGraphicPoints - NÚMERO DE PUNTOS QUE ESTÁN EN GraphicData
  //      (0070,0022) FL GraphicData  -  Puntos en formato    x1/y1/x2/y2 etc
  //      (0070,0023) CS GraphicType  - Tipo de gráfico. Puede ser POINT POLYLINE INTERPOLATED CIRCLE ELLIPSE

  addToToolDataProvider(dataset, referencedImageUID);
  addStandardToToolDataProvider(dataset, referencedImageUID);
}

export function addToToolDataProvider(dataset: any, referencedImageUID: string) {

  let data = findFirstElement(dataset, 'x60010001');

  if (!data) {
    return;
  }

  let concatElem = 1;
  while (findFirstElement(dataset, `x6001000${++concatElem}`)) {
    data += findFirstElement(dataset, `x6001000${concatElem}`);
  }

  // console.log(data);


  const pr: ToolsData = {
    referencedImageUID,
    data
  };

  toolsData.push(pr);
}

export function addStandardToToolDataProvider(dataset: any, referencedImageUID: string) {
  let annotations: any[] = []
  // console.log('dataset', dataset)
  const dicomAnnotations = dataset?.elements['x00700001']?.items[0]?.dataSet?.elements['x00700009']?.items
  // console.log('metadata', dicomAnnotations)

  if(dicomAnnotations!=null) {
    dicomAnnotations.forEach((el: any) => {
      const numberOfPoints = findFirstElement(el.dataSet, `x00700021`);
      // const points = findFirstElement(el.dataSet, `x00700022`);
      const points: any[] = [];
      for (let i = 0; i < el.dataSet.elements[`x00700022`].length / 4; i++) {
        points.push(el.dataSet.float(`x00700022`, i))
      }
      // const points = el.dataSet.string();
      const type = findFirstElement(el.dataSet, `x00700023`);
      // console.log('gráfico: ', { numberOfPoints, points, type });
      annotations.push({ numberOfPoints, points, type })
    })
  }

  const polylineData: any[] = []

  annotations.forEach(ann => {
    if (ann.type == 'POLYLINE') {
      for (let i = 0; i < ann.points.length; i += 4) {
        const handles = { start: { x: ann.points[i], y: ann.points[i + 1] }, end: { x: ann.points[i + 2], y: ann.points[i + 3] } }
        polylineData.push({
          visible: true,
          active: true,
          color: undefined,
          type: ann.type,
          handles,
          invalidated: true,
          // points: ann.points,
        })
      }
    }
    if (ann.type == 'ELLIPSE') {
      // Vienen 4 puntos. Los 2 primeros son los de el eje mayor y los dos segundos los del eje menor
      const points = {
        major: {
          start: { x: ann.points[0], y: ann.points[1] },
          end: { x: ann.points[2], y: ann.points[3] }
        },
        minor: {
          start: { x: ann.points[4], y: ann.points[5] },
          end: { x: ann.points[6], y: ann.points[7] }
        }
      }
      // TODO falta contemplar que los puntos no vengan ordenados, es decir, que start.x < end.x && start.y < end.y
      let handles: { start: { x: number, y: number }, end: { x: number, y: number } } | null = null;
      // Si el eje mayor es el horizontal
      if (points.major.start.x < points.minor.start.x) {
        handles = { start: { x: ann.points[0], y: ann.points[5] }, end: { x: ann.points[2], y: ann.points[7] } }
      } else {
        // Si el eje menor es el horizontal
        handles = { start: { x: ann.points[4], y: ann.points[1] }, end: { x: ann.points[6], y: ann.points[3] } }
      }
      polylineData.push({
        visible: true,
        active: true,
        color: undefined,
        type: ann.type,
        handles,
        invalidated: true,
        // points: ann.points,
      })
    }
    if (ann.type == 'CIRCLE') {
      // TODO https://dicom.innolitics.com/ciods/color-softcopy-presentation-state/graphic-annotation/00700001/00700009/00700023
      // Vienen 2 puntos. El primero es el centro y el segundo es un punto de la circunferencia
    }
    if (ann.type == 'INTERPOLATED') {
      // TODO https://dicom.innolitics.com/ciods/color-softcopy-presentation-state/graphic-annotation/00700001/00700009/00700023
      // Vienen varios puntos y se hacen curvas entre ellos. No estoy muy seguro de cómo se hace
    }
    if (ann.type == 'POINT') {
      // Vienen 1 puntos
      const handles = { start: { x: ann.points[0], y: ann.points[1] } }
      polylineData.push({
        visible: true,
        active: true,
        color: undefined,
        type: ann.type,
        handles,
        invalidated: true,
        // points: ann.points,
      })
    }

  });

  if (toolsData.findIndex(t => t.referencedImageUID == referencedImageUID) != -1) {
    // Si ya tenemos data para esta imagen, la tenemos que adjuntar
    const index = toolsData.findIndex(t => t.referencedImageUID == referencedImageUID);
    const data = JSON.parse(toolsData[index].data);
    if (data.ExternalAnnotations != null) {
      data.ExternalAnnotations.data.push(...polylineData);
    } else {
      data.ExternalAnnotations = { data: polylineData };
    }
    toolsData[index] = {
      referencedImageUID,
      data: JSON.stringify(data)
    }
  } else {
    toolsData.push({
      referencedImageUID,
      data: JSON.stringify({
        ExternalAnnotations: { data: polylineData }
      })
    })
  }

}
